<template>
	<div id="divprint" class="divprint">
		<div v-if="isshowlist" class="printset" :style="bodycss" align="center">
			<pl-table :data="printmode" :height="gridheight" fixedColumnsRoll>
					<pl-table-column prop="p_mode" label="渠道" width="150"></pl-table-column>
					<pl-table-column prop="e_modename" label="模板名称" min-width="30%"></pl-table-column>
					<pl-table-column label="打印机" width="200">
						<template slot-scope="scope">
							<el-select size="mini" v-model="scope.row.u_printer" placeholder="请选择" @change="val=>selectchange(val,scope.row,'printer')">
								<el-option v-for="item in printer" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</pl-table-column>
					<pl-table-column label="纸张尺寸" width="120">
						<template slot-scope="scope">
							<el-select size="mini" v-model="scope.row.u_page" placeholder="请选择">
								<el-option v-for="item in scope.row.pgnamesource" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</pl-table-column>
					<pl-table-column label="布局" width="100">
						<template slot-scope="scope">
							<el-select size="mini" v-model="scope.row.layout" placeholder="请选择">
								<el-option v-for="item in layout" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</pl-table-column>
				</pl-table>
			
		</div>
		
		<el-row :class="footercss" v-if="isshowlist&&checkprinter">
			<el-col :span="6" style="text-align: right; color: transparent;">1
			</el-col>
			<el-col :span="6" class="submitBtn"><div @click="SavePrintSet">保存</div></el-col>
			<el-col :span="1" style="text-align: right; color: transparent;">1
			</el-col>
			<el-col :span="6" class="submitBtn_cancel"><div @click="closepage">取消</div></el-col>
		</el-row>
		<el-row :class="footercss" v-if="isshowlist&&!checkprinter">
			<el-col :span="5" style="text-align: right; color: transparent;">1
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="SavePrintSet">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="closepage">取消</div></el-col>
		</el-row>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		checkprinter: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			gridheight: '300px',
			loading: false,
			printmode: [],
			layout: [{ value: '纵向', label: '纵向' }, { value: '横向', label: '横向' }], //打印方向
			printer: [], //打印机列表
			pgname: [], //指定打印机的纸张
			divclass:'divprint1',
			isshowlist: false,
			bodycss:'margin-top:-20px;height:350px;',
			footercss:'footerhandler'
		};
	},
	mounted() {
		var that;
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/logisticsmanager/printhandler.scss');
			this.init();
		});
	},
	methods: {
		init() {
			//debugger
			if(!this.checkprinter)
			{
				this.bodycss='height:'+(window.innerHeight *76) / 100 +'px;padding-right:10px;padding-left:10px;';
				this.footercss='footerhandlerpage';
				this.gridheight=(window.innerHeight * 55) / 100 + 'px';
			}
			//debugger
			this.isshowlist=false;
			var that = this;
			//读取权限内的
			this.$tool.loading('正在读取设置', that.divclass);
			this.$apipost.get.GetUserPrintset().then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					var showlist=false;
					res.list.forEach(e=>{
						if(e.layout==''||e.layout==null)
							e.layout='纵向';
					});
					that.SetPrinter(res.list);
				} else {
					this.$tool.message(res.message, 0);
					if(that.checkprinter)
						this.$emit('printcheckcallback', { state:1,success: false });
				}
			}).catch(e=>{
				this.$tool.message('网路异常，请重试', 0);
			});
		},
		selectchange(val,row,type){
			if(type=='printer'){
				var pgname=this.$tool.getpagesize(val);
				row.pgnamesource=pgname;
				if(pgname.length>0)
					row.u_page=pgname[0].label;
			}
		},
		SetPrinter(list, param) {
			//读取打印机
			var that = this;
			var isshowlist = false;
			this.printer = this.$tool.getprinterlistall();
			if(this.printer.length>0){
				if (list.length > 0) {
					list.forEach(e=>{
						e.pgnamesource=[];
						if(e.u_printer==''||e.u_printer==null){
							isshowlist=true;
							//e.u_printer=that.printer[0].label;
						}
						var pgname=that.$tool.getpagesize(e.u_printer);
						e.pgnamesource=pgname;
						if(e.u_page==''||e.u_page==null||pgname.length==0){
							isshowlist=true;
							// if(pgname.length>0)
							// 	e.u_page=pgname[0].label;
						}else{
							var isexists=false;
							pgname.forEach(b=>{
								if(b.label==e.u_page)
								{
									isexists=true;
									return false;
								}
							});
							if(!isexists)
								e.u_page=pgname[0].label;
						}
					});
					if (!this.checkprinter){
						this.isshowlist = true;
						this.printmode = list;
					}
					else {
						//设置的打印机是否在本地存在，如果存在则判断打印机设置的纸张是否存在，有不存在的，则显示列表，都存在
						list.forEach(printer => {
							var pgname = that.printer.filter(function(e) {
								return e.label == printer.u_printer;
							});
							if (pgname.length == 0) {
								//表示本地没有匹配到打印机
								isshowlist = true;
								return false;
							} else {
								//表示设置的打印机中在本地存在,开始按打印机查找纸张
								var pagesize = that.$tool.getpagesize(printer.u_printer);
								if (pagesize.length > 0) {
									var pgsize = pagesize.filter(function(e) {
										return e.label == printer.u_page;
									});
									if (pgsize.length == 0) {
										isshowlist = true;
										return false;
									}
								} else {
									isshowlist = true;
									return false;
								}
							}
						});
						if(isshowlist)
						{
							this.printmode = list;
							this.isshowlist = isshowlist;
							this.$emit('printcheckcallback', { state: 0, success:false });
						}
						else
							this.$emit('printcheckcallback', { state: 1, success:true });
					}
				}
			}
			else{
				this.$tool.message('打印机未连接', 0);
				if(this.checkprinter)
					this.$emit('printcheckcallback', {state:1,success: false});
			}
		},
		//保存设置
		SavePrintSet() {
			var that = this;
			var isgo = true;
			for(var i=0;i<this.printmode.length;i++){
				if (this.printmode[i].u_printer == ''||this.printmode[i].u_printer ==null) {
					this.$tool.message(this.printmode[i].e_modename + '未设置打印机', 0);
					isgo = false;
				}
				if(isgo){
					if (this.printmode[i].u_page == ''||this.printmode[i].u_page ==null) {
						this.$tool.message(this.printmode[i].e_modename + '未设置纸张尺寸', 0);
						isgo = false;
					}
				}
				if(!isgo)
					break;
			}
			
			if (!isgo) return false;
			//读取权限内的
			var paraminfo = {
				printmode: this.printmode,
				userid: localStorage.getItem('userid')
			};
			this.$tool.loading('正在保存', that.divclass);
			this.$apipost.post.SavePrintset({ paraminfo: paraminfo }).then(res => {
				
				if (res.state == '1') {
					setTimeout(function(){
						that.$tool.loadingclose();
						if(that.checkprinter)
							that.$emit('printcheckcallback', { state: 1, success: false });
						else
						{
							that.$tool.message('保存成功', 1);
							that.closepage();
						}
					},1500);
				} else {
					this.$tool.loadingclose();
					this.$tool.message(res.message, 0);
				}
			});
		},
		closepage() {
			if (this.checkprinter) {
				this.$emit('printcheckcallback', { state: 1, success: false });
			} else {
				Utils.$emit('handleRermove',localStorage.getItem('tabname'));
			}
		}
	}
};
</script>

<style></style>
